import script from "./page-404.vue?vue&type=script&setup=true&lang=js"
export * from "./page-404.vue?vue&type=script&setup=true&lang=js"

import "./page-404.vue?vue&type=style&index=0&id=42c0a5d1&lang=scss"

const __exports__ = script;

export default __exports__